import { storeToOwnerEmail } from "../pages/dashboards/StoreManagement/constants";

import useAuth from "./useAuth";

// Whether the user may review the seller forecast of `store`. No grant action
// covers the review route, so on the cookie path the backend accepts it only on
// a full_access store; the legacy JWT path has only the hardcoded owner list.
const useCanReviewSellerForecast = (store) => {
  const { method, user } = useAuth();
  if (!user || !store) return false;
  // Legacy client stores arrive suffixed (cleveryoga_client); grant codes never are.
  const code = store.split("_")[0];
  if (method === "cookie") {
    return (user.stores ?? []).some(
      (s) => s.code === code && s.role === "full_access"
    );
  }
  return Boolean(user.email && storeToOwnerEmail[code]?.includes(user.email));
};

export default useCanReviewSellerForecast;
